/**
* ContactBuyBar — sticky bottom CTA: Phone / Line / Email.
* Contact-to-quote model (no cart, no published price). Prefills the
* document context into the mailto so staff can quote per case.
*/
import { SITE } from "@/config/sites";

interface Props {
  productName: string;
  sku: string;
}

export function ContactBuyBar({ productName, sku }: Props) {
  const subj = encodeURIComponent(`ขอใบเสนอราคา: ${productName} (${sku})`);
  const body = encodeURIComponent(
    `สวัสดีครับ/ค่ะ ต้องการสอบถามบริการ ${productName}\n` +
      `SKU: ${sku}\n` +
      `จำนวนหน้า/ชุด: \nภาษาที่ต้องการ: \nกำหนดส่ง: \nจัดส่งที่: \n\nขอบคุณครับ/ค่ะ`,
  );
  const mailto = `mailto:${SITE.contact.email}?subject=${subj}&body=${body}`;
  const tel = `tel:${SITE.contact.phone.replace(/[^+\d]/g, "")}`;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 print:hidden">
      <div className="mx-auto flex max-w-6xl items-stretch gap-2 p-2 sm:p-3">
        <a
          href={tel}
          data-cta="call"
          data-sku={sku}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-primary px-3 py-3 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          <span aria-hidden>📞</span>
          <span className="hidden sm:inline">โทรสอบถาม</span>
          <span className="sm:hidden">โทร</span>
        </a>
        <a
          href={SITE.contact.lineUrl}
          data-cta="line"
          data-sku={sku}
          target="_blank"
          rel="noopener"
          className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-[#06C755] px-3 py-3 text-sm font-semibold text-white hover:opacity-90"
        >
          <span aria-hidden>💬</span>
          <span>Line {SITE.contact.lineId}</span>
        </a>
        <a
          href={mailto}
          data-cta="email"
          data-sku={sku}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg border border-border bg-card px-3 py-3 text-sm font-semibold text-foreground hover:bg-muted"
        >
          <span aria-hidden>✉️</span>
          <span className="hidden sm:inline">อีเมล</span>
          <span className="sm:hidden">Mail</span>
        </a>
      </div>
    </div>
  );
}
